import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { DireccionComponent } from "app/features/componentes/direccion/direccion";

type Entity = models.DocumentacionDTO;

export interface Props {
    value: Entity;
}


/**
* Componente para editar un Entity
*/
export class DatosDocumentacion extends React.PureComponent<Props> {
    getField = formfields(() => ({ value: this.props.value, readonly: true }));



    render() {
        const { value } = this.props;
        const getField = this.getField;
        const direccion: models.DireccionColonia = {
            ...value.DireccionOrigen,
            IdColonia: value.IdColoniaOrigen,
        };;

        const Text = getField(kea.Text);
        const DateTime = getField(kea.DateTime);
        const Number = getField(kea.Number);

        return (
            <div>

                {kea.autogrid(6, [
                    <kea.Panel title="Generales" iconClass={fa("list-alt")} >
                        {kea.autogrid(6, [
                            <Text field="NombreClienteOrigen" label="Cliente origen" />,
                            <Text field="NombreContactoOrigen" label="Contacto origen" />,
                            <DateTime field="FechaCreacion" label="Fecha de creación" />,
                            <Number field="ImporteDestino" label="Importe destino" format="currency" />,
                            <Number field="ImporteOrigen" label="Importe origen" format="currency" />,
                            <Number field="DivisorPesoVolumetrico" label="Divisor del peso volumétrico" />,
                        ])}
                    </kea.Panel>,
                    <DireccionComponent value={direccion} readonly={true} label="Dirección de origen" />,
                ])}
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/listados/documentacion/edit/datosdocumentacion.tsx